export enum SuicideScreeningTypeEnum {
    Screening = "Screening",
    ReScreening = "ReScreening"
}
